// extracted by mini-css-extract-plugin
export default {"countBlock":"count-block__eoaBEalw","calculationSelector":"calculation-selector__grNMwwd5","removeButton":"remove-button__LvPsdvRJ"};